<template>
  <div class="view-container">
    <!-- 删除按钮 -->
    <div class="delete-icon" v-if="del">
      <svg
        class="icon grey-icon"
        aria-hidden="true">
        <use xlink:href="#icon-moren-guanbi"></use>
      </svg>
      <svg
        class="icon red-icon"
        aria-hidden="true"
        @click="handleDeleteFile">
        <use xlink:href="#icon-huaguo-guanbi"></use>
      </svg>
    </div>
    <!-- 占位图 -->
    <div class="view-img">
      <div :class="covered ? 'covered' : 'partly'">
        <img
          v-if="placeholderImg"
          :src="placeholderImg"
          alt="">
      </div>
    </div>
    <!-- 查看按钮 -->
    <div class="view-icon">
      <svg
        class="icon grey-icon"
        aria-hidden="true">
        <use xlink:href="#icon-sousuo1"></use>
      </svg>
      <svg
        class="icon blue-icon"
        aria-hidden="true"
        @click="handleViewFile">
        <use xlink:href="#icon-huaguo-sousuo"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import uploadApi from '@/api/upload'
import { openBlob } from '@/utils/utils'
import pdfPng from '@/assets/image/upload/pdf.png'
import excelPng from '@/assets/image/upload/excel.png'
export default {
  props: {
    // 三个属性 type name path openByBrowser
    file: {
      type: Object,
      default () {
        return {}
      }
    },
    // 是否可删除
    del: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 占位图
      placeholderImg: '',
      // 占位图是否铺满容器
      covered: true,
      mimes: [
        {
          mime: 'application/pdf',
          regExp: /\.pdf$/,
          openInBrowser: true
        },
        {
          mime: 'image/jpg',
          regExp: /\.jpg$/,
          openInBrowser: true
        },
        {
          mime: 'image/jpeg',
          regExp: /\.jpeg$/,
          openInBrowser: true
        },
        {
          mime: 'image/png',
          regExp: /\.png$/,
          openInBrowser: true
        },
        {
          mime: 'application/vnd.ms-excel',
          regExp: /\.xls$/
        },
        {
          mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          regExp: /\.xlsx$/
        }
      ]
    }
  },
  watch: {
    file: {
      handler (val) {
        const { type, path } = val
        if (!path) return
        // 保证文件都有type 如果没有type 则根据文件名兼容
        if (!type) {
          const target = this.mimes.filter(item => item.regExp.test(path.toLowerCase()))
          if (target && target.length) {
            // 如果有满足条件的mime的话
            val.type = target[0].mime
          } else {
            // 否则，先暂且按 application/pdf 处理
            val.type = 'application/pdf'
          }
        }
        // 根据mime处理
        if (val.type === 'application/pdf') {
          this.placeholderImg = pdfPng
          this.covered = false
        } else if (val.type === 'application/vnd.ms-excel' || val.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.placeholderImg = excelPng
          this.covered = false
        } else {
          uploadApi.downloadFile({
            fileName: path
          }).then(res => {
            if (res) {
              // blobUrl在IE浏览器上能正常展示 所以这里不作额外处理
              this.placeholderImg = URL.createObjectURL(res)
            }
          }).catch(err => {
            console.error(err)
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteFile () {
      const { file } = this
      this.$emit('delete', file)
    },
    handleViewFile () {
      const { type, path, openByBrowser } = this.file
      if (!type || !path) return
      // 如果文件没在ftp上 直接利用浏览器打开
      if (openByBrowser) {
        window.open(path)
      } else {
        uploadApi.downloadFile({
          fileName: path
        }).then(res => {
          if (res) {
            openBlob(res, type)
          }
        }).catch(err => {
          console.error(err)
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.view-container {
  position: relative;
  width: 120px;
  height: 120px;
  margin-right: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #E6E9F4;
  &:hover {
    border: 1px solid #4A6AFF;
  }
  .delete-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    &:hover {
      .grey-icon {
        display: none;
      }
      .red-icon {
        display: block;
      }
    }
    > .icon {
      width: 100%;
      height: 100%;
      user-select: none;
    }
    .grey-icon {
      display: block;
    }
    .red-icon {
      display: none;
    }
  }
  .view-img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    .covered {
      width: 100%;
      height: 100%;
    }
    .partly {
      width: 60px;
      height: 60px;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .view-icon {
    position: absolute;
    right: 5px;
    bottom: 5px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    &:hover {
      .grey-icon {
        display: none;
      }
      .blue-icon {
        display: block;
      }
    }
    > .icon {
      width: 100%;
      height: 100%;
      user-select: none;
    }
    .grey-icon {
      display: block;
    }
    .blue-icon {
      display: none;
    }
  }
}
</style>
